module.exports = __webpack_public_path__ + "static/media/facebook.e2cd4863.svg";